var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.done)?_c('span',{key:_vm.id,domProps:{"innerHTML":_vm._s(_vm.translation)}}):_c('span',{key:_vm.id,ref:"phrase",staticClass:"phrase-mounting"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }